/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    header: {
      paddingTop: 1,
      paddingRight: [4, 4, 6, 6],
      paddingBottom: 1,
      paddingLeft: [4, 4, 6, 6],
      boxShadow: 'base',
    },
    body: {
      padding: [4, 4, 6, 6],
    },
    footer: {
      paddingTop: 6,
      paddingRight: [4, 4, 6, 6],
      paddingBottom: 11,
      paddingLeft: [4, 4, 6, 6],
    },
  },
};
